<div class="">
<div class="container-fluid pt-1 mb-3  thin-scroll">
    <div class="header p-2 my-2 d-flex  justify-content-between align-items-center">
        <h6><span  class="headertxt"> {{l("APContact")}} : </span></h6>   
        <div >
            <button
            *ngIf="canChange"
            (click)="showEditMode()"
            class="previewbtn text-center btn float-right"
        >
        <img src="../../../../../assets/shoppingCart/edit.png"
        class="imgIcon" />
        <span class="mx-1 text-white"> Edit</span>
            
        </button>
        </div>
    </div>
    <hr class="my-2" />
    <div class="InfoForm pr-3 thin-scroll">
        <div class="row ml-1"> 
            <app-contact 
            class="w-100"  
             [billingIndexInfo]="1"
            [isCreateOrEdit]="createOrEditBillingInfo" [activeTab]="activeTab"
            [currentTab]="currentTab"
                [appTransactionsForViewDto]="appTransactionsForViewDto"
                (updateAppTransactionsForViewDto)="onUpdateAppTransactionsForViewDto($event)"
                (formValidityChanged)="isContactFormValid_1($event)"
                ></app-contact>
        </div>
    </div>
    <hr class="my-2" />
    <app-address 
    [appTransactionsForViewDto]="appTransactionsForViewDto"
    [isCreateOredit]="createOrEditBillingInfo"
    [contactId]="contactIdApContact"
    [selectedAddressDetails]="selectedAddressDetailsAp"
    [showAddressType]="false"
    [canChange]="canChange"
    [currentTab]="currentTab"
    ></app-address>
    
</div>
<div class="container-fluid pt-1 mb-3">
    <div class="header p-2 my-2 d-flex align-items-center">
        <h6><span  class="headertxt"> {{l("ARContact")}} : </span></h6>   
    </div>
    <hr class="my-2" />
    <div class="InfoForm pr-3 thin-scroll">
        <div class="row ml-1"> 
            <app-contact 
            class="w-100"  
             [billingIndexInfo]="2"
            [isCreateOrEdit]="createOrEditBillingInfo" [activeTab]="activeTab"
            [currentTab]="currentTab"
                [appTransactionsForViewDto]="appTransactionsForViewDto"
                (updateAppTransactionsForViewDto)="onUpdateAppTransactionsForViewDto($event)"
                (formValidityChanged)="isContactFormValid_2($event)"
                ></app-contact>
        </div>
    </div>
    <hr class="my-2" />
    <app-address 
    [appTransactionsForViewDto]="appTransactionsForViewDto"
    [isCreateOredit]="createOrEditBillingInfo"
    [contactId]="contactIdARContact"
    [selectedAddressDetails]="selectedAddressDetailsAr"
    [showAddressType]="false"
    [canChange]="canChange"
    [currentTab]="currentTab"
    ></app-address>

</div>
<div class="container-fluid pt-1 mb-3 mt-3">
    <div class="header p-2 my-2 d-flex  justify-content-between">
        <h6><span  class="headertxt">{{l("PaymentInformation")}} : </span></h6>
    </div>
    <div class="row view-mode mt-2 mb-2">
        <div class="col-md-6 col-12" style="margin-left: 7px;" *ngIf="appTransactionsForViewDto?.paymentTermsCode">
            <label class="label mt-1 mb-1  w-50">{{l("PaymentTerms")}}</label>
            <label class="label mt-1 mb-1 w-50">{{appTransactionsForViewDto?.paymentTermsName}}</label>
    
        </div>

    </div>
    </div>
</div>

